/**
 * Trip score display helpers.
 * Score is computed server-side (DriverScoreService::computeTripScore).
 * Green (8+), amber (5-7.9), red (<5). Returns Vuetify color names.
 */
export function useTripScore() {
    const tripScoreColor = (score) => {
        const s = parseFloat(score);
        if (isNaN(s)) return 'grey';
        if (s >= 8.0) return 'success';
        if (s >= 5.0) return 'warning';
        return 'error';
    };

    const formatTripScore = (score) => {
        if (score === null || score === undefined) return null;
        const s = parseFloat(score);
        if (isNaN(s)) return null;
        return s.toFixed(1);
    };

    const hasTripScore = (trip) => {
        return trip?.trip_score !== null && trip?.trip_score !== undefined;
    };

    return { tripScoreColor, formatTripScore, hasTripScore };
}
